module.exports = __webpack_public_path__ + "media/images/vector_admin02-4262be3adc16b227803906fdd846a604.svg";